import React from "react";
import { Flex, Grid, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// 시작 전에 보여줄 3개 정보 — 횟수(1회)는 카드에서 빼고 하단 각주로만 안내한다.
const ROWS = ["plan", "period", "product"] as const;

/**
 * 무료체험 조건 확인 모달.
 *
 * `시작하기` 를 누른 시점부터 48시간을 계산하므로, 조건을 먼저 못 박아 보여준다.
 */
function PathPickStartGuideFreeTrialModal({
  isOpen,
  onClose,
  onConfirm,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick_guide:free_trial.modal.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-sm-medium"} color={"#6F6F6C"}>
            {t("path_pick_guide:free_trial.modal.body")}
          </Text>
          <Grid gridTemplateColumns={"repeat(3, minmax(0, 1fr))"} gap={"8px"}>
            {ROWS.map((row) => (
              <Flex
                key={row}
                flexDirection={"column"}
                gap={"4px"}
                alignItems={"center"}
                padding={"12px 8px"}
                borderRadius={"8px"}
                border={"0.5px solid #E5E5E3"}
                backgroundColor={"#F8F9FB"}
              >
                <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
                  {t(`path_pick_guide:free_trial.modal.${row}_label`)}
                </Text>
                <Text textStyle={"body-sm-bold"} color={"#22221F"}>
                  {t(`path_pick_guide:free_trial.modal.${row}_value`)}
                </Text>
              </Flex>
            ))}
          </Grid>
          <Text textStyle={"caption-medium"} color={"#6F6F6C"}>
            {t("path_pick_guide:free_trial.modal.footnote")}
          </Text>
        </Flex>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        cancelName={t("path_pick_guide:free_trial.modal.cancel")}
        confirmName={t("path_pick_guide:free_trial.modal.confirm")}
        onCancel={onClose}
        onConfirm={onConfirm}
      />
    </CustomApprovalModal>
  );
}

export default PathPickStartGuideFreeTrialModal;
